import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import Titulo from '../comum/Titulo';
import buscarEmpresasGestao from '../../actions/empresa/buscarEmpresasGestao';
import excluirEmpresa from '../../actions/empresa/excluirEmpresas';
import { alterouFiltro, alterouPagina, montarURLFiltro } from '../../util/filtros';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Empresa from './Empresa';
import buscarImpostosEmpresa from '../../actions/imposto-empresa/buscarImpostosEmpresa';
import buscarImpostos from '../../actions/imposto/buscarImpostos';

import ModalCadastrarImposto from '../imposto-empresa/ModalCadastrarImposto';
import PainelFiltragem from './PainelFiltrosEmpresas';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoEmpresas from './PaginacaoEmpresas';
import BotoesPaginacaoEmpresas from './BotoesPaginacaoEmpresas';
import determinarPaginaAtual from '../../actions/empresa/determinarPaginaAtualEmpresas';
import alterarRegistrosPorPagina from '../../actions/empresa/alterarRegistrosPorPaginaEmpresas';
import bloquearEmpresa from '../../actions/empresa/bloquearEmpresa';
import desbloquearEmpresa from '../../actions/empresa/desbloquearEmpresa';
import configurarCieloLinkEmpresa from '../../actions/empresa/configurarCieloLinkEmpresa';
import configurarCieloEcommerceEmpresa from '../../actions/empresa/configurarCieloEcommerceEmpresa';
import configurarSicoobEmpresa from '../../actions/empresa/configurarSicoobEmpresa';
import listarChavesPixSicoob from '../../actions/empresa/listarChavesPixSicoob';
import cadastrarChavePixSicoob from '../../actions/empresa/cadastrarChavePixSicoob';
import removerChavePixSicoob from '../../actions/empresa/removerChavePixSicoob';
import replicarConfiguracaoSicoob from '../../actions/empresa/replicarConfiguracaoSicoob';
import recuperarConfiguracaoStoneConnect from '../../actions/empresa/recuperarConfiguracaoStoneConnect';
import configurarStoneConnect from '../../actions/empresa/configurarStoneConnect';
import ReactTooltip from 'react-tooltip';
import buscarEmpresaPorId from '../../actions/empresa/buscarEmpresaPorId';
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import { isAmbienteDev } from '../../util/applicationContext';

const thStyle = {padding:'11px 10px', fontWeight:600, color:'#555', fontSize:11, textTransform:'uppercase', letterSpacing:.4, borderBottom:'2px solid #eee', background:'#f8f8f8', whiteSpace:'nowrap'};

const UF_SICOOB = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

const ModalConfirmacaoExclusaoEmpresa = ({ excluir, empresa }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoEmpresa" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{borderTop:'4px solid #c62828', borderRadius:12}}>
                <div className="modal-header" style={{borderBottom:'1px solid #f0f0f0'}}>
                    <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                        <i className="material-icons" style={{color:'#c62828', fontSize:20}}>delete</i>
                        Excluir Empresa
                    </h5>
                    <button type="button" className="close" data-dismiss="modal"><i className="material-icons">close</i></button>
                </div>
                <div className="modal-body" style={{textAlign:'center', padding:'20px 24px'}}>
                    <p style={{margin:0, fontSize:14}}>Deseja excluir a empresa <strong>{empresa ? empresa.nome : ''}</strong>?</p>
                </div>
                <div className="modal-footer" style={{borderTop:'1px solid #f0f0f0'}}>
                    <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="btn" data-dismiss="modal"
                        onClick={() => excluir()}
                        style={{background:'#c62828', color:'#fff', fontWeight:700}}>Excluir</button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoBloqueioEmpresa = ({ bloquearDesbloquear, empresa }) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioEmpresa" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{borderTop:'4px solid #FF6A00', borderRadius:12}}>
                <div className="modal-header" style={{borderBottom:'1px solid #f0f0f0'}}>
                    <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                        <i className="material-icons" style={{color:'#FF6A00', fontSize:20}}>
                            {empresa && empresa.bloqueada ? 'lock_open' : 'lock'}
                        </i>
                        {empresa && empresa.bloqueada ? 'Desbloquear' : 'Bloquear'} Empresa
                    </h5>
                    <button type="button" className="close" data-dismiss="modal"><i className="material-icons">close</i></button>
                </div>
                <div className="modal-body" style={{textAlign:'center', padding:'20px 24px'}}>
                    <p style={{margin:0, fontSize:14}}>
                        Deseja {empresa && empresa.bloqueada ? 'desbloquear' : 'bloquear'} a
                        empresa <strong>{empresa ? empresa.nome : ''}</strong>?
                    </p>
                </div>
                <div className="modal-footer" style={{borderTop:'1px solid #f0f0f0'}}>
                    <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="btn btn-laranja" data-dismiss="modal"
                        onClick={() => bloquearDesbloquear()}>Confirmar</button>
                </div>
            </div>
        </div>
    </div>);


export class PainelGerenciarEmpresas extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarEmpresa = this.selecionarEmpresa.bind(this);
        this.excluir = this.excluir.bind(this);

        this.state = {
            empresaSelecionada: null,
            impostos: [],
            cieloLink: { habilitadoLinkPagamento: false, clientIdCieloLink: '', clientSecretCieloLink: '' },
            cieloEcommerce: { habilitadoCieloEcommerce: false, merchantIdCieloEcommerce: '', merchantKeyCieloEcommerce: '' },
            sicoob: { habilitadoSicoob: false },
            chavesPixSicoob: [],
            // cada configuração é autocontida (certificado + client_id + senha próprios),
            // não existe mais uma "credencial única" da empresa -- ver plano de ajuste
            novaConfiguracaoSicoob: { uf: '', chavePix: '', apelido: '', clientId: '', certificadoBase64: '', nomeCertificado: '', senhaCertificado: '', accessTokenSandbox: '' },
            configuracaoReplicandoId: null,
            ufsReplicar: [],
            // chaveSecreta sempre abre em branco (nunca preenchida com o valor real vindo do
            // backend, que só informa chaveSecretaConfigurada) -- pedido explícito do usuário,
            // ver plano de integração Connect Stone, seção 6.1
            stoneConnect: { habilitadoStoneConnect: false, serviceRefererName: '', chaveSecreta: '', chaveSecretaConfigurada: false, installmentType: 'merchant', meiosPagamentoHabilitados: [], modosCriacaoPedidoHabilitados: [], limiteParcelamento: null }
        };
    }

    async downloadParte(url, size, from) {
        const urlFiltros = montarURLFiltro(this.props.filtrosAdicionados);
        
        let urlReq = `${url}?size=${size}&from=${from}&${urlFiltros}`;
        
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);
                
        return retorno.data;
    }
        
    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'Lista de Empresas.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarListaEmpresas() {
        let arquivo = 'Id Empresa;Nome Razão Social;Nome Fantasia;CNPJ;Email;Data Criação;Telefone;Grupo\n';
        let url = `${URL}/empresas`;
        
        let count = 0;
        let from = 1;
        let size = 10000;

        let qtd = this.props.total;        
        let totalParticoes = Math.ceil(qtd / 10000);
        
        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, size, from);
            
            arquivo = `${arquivo}${retorno.empresas.map(it => {
                const telefone = (it.telefones && it.telefones.length > 0) ? it.telefones[0] : ''
                const grupo = it.grupo ? it.grupo : ''

                let valor = `"${it.id}";"${it.nome}";"${it.nomeFantasia}";${it.cnpj};${it.email};${it.dataCriacao};${telefone};${grupo}`
                if (it.configuracoesBPe.length > 0) {
                    valor = `${valor}\n;UF;Inscrição Estadual\n`
                    it.configuracoesBPe.forEach(it => {                                             
                        valor = `${valor};${it.uf};${it.inscricaoEstadual}\n`

                    });

                }

                return valor;

            }).join('\n')}\n`;

            from += 1;
            count += 1;

            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }            
        }

    }

    buscarEmpresasGestao() {
        this.props.buscarEmpresasGestao(this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidMount() {
        this.buscarEmpresasGestao();
        this.props.buscarImpostos()
            .then(resp => {
                if (resp.payload.status === 200) {
                    this.setState({ impostos: resp.payload.data })
                }
            })
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarEmpresasGestao();
        }
    }

    bloquearDesbloquear() {
        if (this.state.empresaSelecionada.bloqueada) {
            this.props.desbloquearEmpresa(this.state.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarEmpresasGestao();
                    }
                })
        } else {
            this.props.bloquearEmpresa(this.state.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarEmpresasGestao();
                    }
                })
        }
    }

    // renovar () {
    //   axios.post(`${URL}/empresa/atualizar-vinculo-mp`, {}, SLOW_REQUEST_CONFIG)
    //     .then(() => {
    //       Alert.success(
    //         `<div class='col-md-2 icone-feedback posicao-camada'>${ICONE_SUCESSO}</div>
    //               <div class='col-md-10 mensagem-feedback posicao-camada'>Vínculos Atualizados com sucesso</div>`,
    //         configuracaoMensagemAlerta
    //       )
    //     })
    // }

    buscarImpostoEmpresa(id) {
        this.props.buscarImpostosEmpresa(id)
    }

    limparEmpresaSelecionado() {
        this.setState({ empresaSelecionada: null });
    }


    excluir() {
        this.props.excluirEmpresa(this.state.empresaSelecionada.id)
            .then(() => {
                this.buscarEmpresasGestao();
                this.limparEmpresaSelecionado();
            })
    }

    selecionarEmpresa(empresa) {
        this.setState({ empresaSelecionada: empresa });
    }

    abrirModalCieloLink(empresa) {
        this.setState({ empresaSelecionada: empresa });
        this.props.buscarEmpresaPorId(empresa.id).then(resp => {
            const e = resp.payload.data;
            this.setState({
                cieloLink: {
                    habilitadoLinkPagamento: e.habilitadoLinkPagamento || false,
                    clientIdCieloLink: e.clientIdCieloLink || '',
                    clientSecretCieloLink: e.clientSecretCieloLink || ''
                }
            });
        });
    }

    salvarCieloLink() {
        const { empresaSelecionada, cieloLink } = this.state;
        this.props.configurarCieloLinkEmpresa(empresaSelecionada.id, cieloLink)
            .then(() => {
                showSuccessMsg('Configurações Cielo Link salvas com sucesso!');
                document.querySelector('#modalCieloLinkEmpresa [data-dismiss="modal"]').click();
                this.buscarEmpresasGestao();
            })
            .catch(() => showAlertMsg('Erro ao salvar configurações Cielo Link.'));
    }

    abrirModalCieloEcommerce(empresa) {
        this.setState({ empresaSelecionada: empresa });
        this.props.buscarEmpresaPorId(empresa.id).then(resp => {
            const e = resp.payload.data;
            this.setState({
                cieloEcommerce: {
                    habilitadoCieloEcommerce: e.habilitadoCieloEcommerce || false,
                    merchantIdCieloEcommerce: e.merchantIdCieloEcommerce || '',
                    merchantKeyCieloEcommerce: e.merchantKeyCieloEcommerce || ''
                }
            });
        });
    }

    salvarCieloEcommerce() {
        const { empresaSelecionada, cieloEcommerce } = this.state;
        this.props.configurarCieloEcommerceEmpresa(empresaSelecionada.id, cieloEcommerce)
            .then(() => {
                showSuccessMsg('Configurações Cielo E-commerce salvas com sucesso!');
                document.querySelector('#modalCieloEcommerceEmpresa [data-dismiss="modal"]').click();
                this.buscarEmpresasGestao();
            })
            .catch(() => showAlertMsg('Erro ao salvar configurações Cielo E-commerce.'));
    }

    abrirModalSicoob(empresa) {
        this.setState({ empresaSelecionada: empresa, configuracaoReplicandoId: null, ufsReplicar: [] });
        this.props.buscarEmpresaPorId(empresa.id).then(resp => {
            const e = resp.payload.data;
            this.setState({ sicoob: { habilitadoSicoob: e.habilitadoSicoob || false } });
        });
        this.carregarChavesPixSicoob(empresa.id);
    }

    carregarChavesPixSicoob(empresaId) {
        // listarChavesPixSicoob retorna a promise do axios direto (sem dispatch de action
        // com payload, diferente de buscarEmpresaPorId) -- é resp.data, não resp.payload.data
        this.props.listarChavesPixSicoob(empresaId)
            .then(resp => this.setState({ chavesPixSicoob: resp.data }))
            .catch(() => showAlertMsg('Erro ao carregar configurações Sicoob.'));
    }

    salvarSicoob() {
        const { empresaSelecionada, sicoob } = this.state;
        this.props.configurarSicoobEmpresa(empresaSelecionada.id, sicoob)
            .then(() => {
                showSuccessMsg('Configurações Sicoob salvas com sucesso!');
                this.buscarEmpresasGestao();
            })
            .catch(() => showAlertMsg('Erro ao salvar configurações Sicoob.'));
    }

    handleCertificadoSicoob(file) {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            // remove o prefixo "data:*/*;base64," do resultado do FileReader
            const base64 = reader.result.split(',')[1];
            this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, certificadoBase64: base64, nomeCertificado: file.name } });
        };
        reader.readAsDataURL(file);
    }

    salvarNovaConfiguracaoSicoob() {
        const { empresaSelecionada, novaConfiguracaoSicoob } = this.state;
        if (!novaConfiguracaoSicoob.chavePix || !novaConfiguracaoSicoob.clientId) {
            showAlertMsg('Preencha chave PIX e Client ID.');
            return;
        }
        // qual campo é obrigatório depende do ambiente da aplicação em execução (mesmo dado
        // do GET /ambiente), não de uma escolha manual -- produção usa certificado/mTLS,
        // sandbox usa um access_token colado manualmente (Sicoob não exige mTLS lá)
        if (isAmbienteDev()) {
            if (!novaConfiguracaoSicoob.accessTokenSandbox) {
                showAlertMsg('Preencha o Access Token de sandbox.');
                return;
            }
        } else if (!novaConfiguracaoSicoob.certificadoBase64 || !novaConfiguracaoSicoob.senhaCertificado) {
            showAlertMsg('Preencha certificado e senha do certificado.');
            return;
        }
        const dados = {
            ...novaConfiguracaoSicoob,
            uf: novaConfiguracaoSicoob.uf || null,
            ambiente: isAmbienteDev() ? 'SANDBOX' : 'PRODUCAO'
        };
        this.props.cadastrarChavePixSicoob(empresaSelecionada.id, dados)
            .then(() => {
                showSuccessMsg('Configuração Sicoob cadastrada com sucesso!');
                this.setState({ novaConfiguracaoSicoob: { uf: '', chavePix: '', apelido: '', clientId: '', certificadoBase64: '', nomeCertificado: '', senhaCertificado: '', accessTokenSandbox: '' } });
                this.carregarChavesPixSicoob(empresaSelecionada.id);
            })
            .catch(() => showAlertMsg('Erro ao cadastrar configuração Sicoob.'));
    }

    removerChavePixSicoob(chaveId) {
        const { empresaSelecionada } = this.state;
        this.props.removerChavePixSicoob(empresaSelecionada.id, chaveId)
            .then(() => {
                showSuccessMsg('Configuração Sicoob removida com sucesso!');
                this.carregarChavesPixSicoob(empresaSelecionada.id);
            })
            .catch(() => showAlertMsg('Erro ao remover configuração Sicoob.'));
    }

    abrirReplicar(configuracaoId) {
        const abrindo = this.state.configuracaoReplicandoId !== configuracaoId;
        this.setState({ configuracaoReplicandoId: abrindo ? configuracaoId : null, ufsReplicar: [] });
    }

    toggleUfReplicar(uf) {
        const { ufsReplicar } = this.state;
        this.setState({
            ufsReplicar: ufsReplicar.includes(uf) ? ufsReplicar.filter(u => u !== uf) : [...ufsReplicar, uf]
        });
    }

    confirmarReplicar() {
        const { empresaSelecionada, configuracaoReplicandoId, ufsReplicar } = this.state;
        if (ufsReplicar.length === 0) {
            showAlertMsg('Selecione ao menos um estado para replicar.');
            return;
        }
        this.props.replicarConfiguracaoSicoob(empresaSelecionada.id, configuracaoReplicandoId, ufsReplicar)
            .then(() => {
                showSuccessMsg('Configuração replicada com sucesso!');
                this.setState({ configuracaoReplicandoId: null, ufsReplicar: [] });
                this.carregarChavesPixSicoob(empresaSelecionada.id);
            })
            .catch(() => showAlertMsg('Erro ao replicar configuração Sicoob.'));
    }

    abrirModalStoneConnect(empresa) {
        this.setState({ empresaSelecionada: empresa });
        this.props.recuperarConfiguracaoStoneConnect(empresa.id)
            .then(resp => {
                const c = resp.data;
                this.setState({
                    stoneConnect: {
                        habilitadoStoneConnect: c.habilitadoStoneConnect || false,
                        serviceRefererName: c.serviceRefererName || '',
                        chaveSecreta: '',
                        chaveSecretaConfigurada: c.chaveSecretaConfigurada || false,
                        installmentType: c.installmentType || 'merchant',
                        meiosPagamentoHabilitados: c.meiosPagamentoHabilitados || [],
                        modosCriacaoPedidoHabilitados: c.modosCriacaoPedidoHabilitados || [],
                        limiteParcelamento: c.limiteParcelamento || null
                    }
                });
            })
            .catch(() => showAlertMsg('Erro ao carregar configuração Stone Connect.'));
    }

    toggleMeioPagamentoStone(valor, marcado) {
        const { meiosPagamentoHabilitados } = this.state.stoneConnect;
        const novaLista = marcado
            ? [...meiosPagamentoHabilitados, valor]
            : meiosPagamentoHabilitados.filter(m => m !== valor);
        this.setState({ stoneConnect: { ...this.state.stoneConnect, meiosPagamentoHabilitados: novaLista } });
    }

    toggleModoCriacaoPedidoStone(valor, marcado) {
        const { modosCriacaoPedidoHabilitados } = this.state.stoneConnect;
        const novaLista = marcado
            ? [...modosCriacaoPedidoHabilitados, valor]
            : modosCriacaoPedidoHabilitados.filter(m => m !== valor);
        this.setState({ stoneConnect: { ...this.state.stoneConnect, modosCriacaoPedidoHabilitados: novaLista } });
    }

    salvarStoneConnect() {
        const { empresaSelecionada, stoneConnect } = this.state;
        if (stoneConnect.habilitadoStoneConnect && stoneConnect.meiosPagamentoHabilitados.length === 0) {
            showAlertMsg('Selecione ao menos um meio de pagamento Stone.');
            return;
        }
        if (stoneConnect.habilitadoStoneConnect && stoneConnect.modosCriacaoPedidoHabilitados.length === 0) {
            showAlertMsg('Selecione ao menos um modo de criação do pedido.');
            return;
        }
        this.props.configurarStoneConnect(empresaSelecionada.id, stoneConnect)
            .then(() => {
                showSuccessMsg('Configurações Stone Connect salvas com sucesso!');
                // recarrega para atualizar chaveSecretaConfigurada e voltar a esconder a chave
                this.abrirModalStoneConnect(empresaSelecionada);
                this.buscarEmpresasGestao();
            })
            .catch(() => showAlertMsg('Erro ao salvar configurações Stone Connect.'));
    }

    // Ícone de ajuda + tooltip por campo (pedido explícito do usuário) -- mesmo padrão já
    // usado em exibirIconeAjudaRegra (ModalPainelRegraControleEmissaoBpe.js:166-179):
    // react-tooltip, ícone material-icons "help" como gatilho.
    // eslint-disable-next-line class-methods-use-this
    exibirIconeAjudaCampo(tooltipId, tooltipContent) {
        return (
            <span className='align-self-center tooltip-info' style={{ marginLeft: 6 }}>
                <a data-tip data-for={tooltipId}>
                    <i className='material-icons ajuda-icon' style={{ color: '#888', fontSize: 16, verticalAlign: 'middle' }}>help</i>
                </a>
                <ReactTooltip className='tooltip-ut' id={tooltipId} type='dark' effect='solid'>
                    <div style={{ maxWidth: 260 }}>{tooltipContent}</div>
                </ReactTooltip>
            </span>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoes() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="vx-page-toolbar" style={{marginBottom:20}}>
                    <div style={{display:'flex', alignItems:'center', gap:12}}>
                        <div style={{width:40, height:40, borderRadius:10, background:'linear-gradient(135deg,#FF6A00,#e05a00)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                            <i className="material-icons" style={{color:'#fff', fontSize:22}}>business</i>
                        </div>
                        <div>
                            <div style={{fontWeight:700, fontSize:15, color:'#1a1a1a', lineHeight:1.2}}>Empresas Cadastradas</div>
                            {this.props.total > 0 && (
                                <div style={{fontSize:12, color:'#888', marginTop:2}}>{this.props.total} empresa{this.props.total !== 1 ? 's' : ''} encontrada{this.props.total !== 1 ? 's' : ''}</div>
                            )}
                        </div>
                    </div>
                    <div style={{display:'flex', gap:8}}>
                        <button className="vx-toolbar-btn vx-toolbar-btn--secondary"
                            onClick={() => this.exportarListaEmpresas()}>
                            <i className="material-icons">file_download</i>
                            Exportar
                        </button>
                        <Link to="/painel-empresas/nova" className="vx-toolbar-btn">
                            <i className="material-icons">add</i>
                            Nova Empresa
                        </Link>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirTabelaEmpresas() {
        if (this.props.empresas && this.props.empresas.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoEmpresas}
                    BotoesPaginacao={BotoesPaginacaoEmpresas}>
                    <div className="vx-table-scroll">
                        <table style={{width:'100%', fontSize:13, borderCollapse:'collapse', minWidth:700}}>
                            <thead>
                                <tr>
                                    <th style={{...thStyle, width:70}}>ID</th>
                                    <th style={thStyle}>Nome</th>
                                    <th style={thStyle}>Nome Fantasia</th>
                                    <th style={thStyle}>CNPJ/CPF</th>
                                    <th style={thStyle}>Email</th>
                                    <th style={thStyle}>Criação</th>
                                    <th style={{...thStyle, width:52, textAlign:'center'}}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.exibirEmpresas()}
                            </tbody>
                        </table>
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div className="vx-empty-state"><i className="material-icons">business</i><p>Nenhuma empresa cadastrada</p></div>;
    }

    exibirEmpresas() {
        return this.props.empresas
            .map((empresa, index) => <Empresa key={index} empresa={empresa}
                buscarImpostoEmpresa={this.buscarImpostoEmpresa.bind(this)}
                selecionarEmpresa={this.selecionarEmpresa}
                abrirModalCieloLink={this.abrirModalCieloLink.bind(this)}                
                abrirModalCieloEcommerce={this.abrirModalCieloEcommerce.bind(this)}
                abrirModalSicoob={this.abrirModalSicoob.bind(this)}
                abrirModalStoneConnect={this.abrirModalStoneConnect.bind(this)}
                indice={index} />)
    }

    exibirFiltro() {
        return <PainelFiltragem />;
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="container-padrao">
                    <Titulo texto="Gerenciar Empresas" urlRetorno="/" />
                    {this.exibirFiltro()}
                    <div className="vx-table-card">
                        {this.exibirBotoes()}
                        {this.exibirTabelaEmpresas()}
                    </div>
                </div>
                <ModalCadastrarImposto
                    buscarImpostosEmpresa={this.buscarImpostoEmpresa.bind(this)}
                    impostosEmpresa={this.props.impostosEmpresa}
                    empresa={this.state.empresaSelecionada}
                    impostos={this.state.impostos} />
                <ModalConfirmacaoExclusaoEmpresa excluir={this.excluir} empresa={this.state.empresaSelecionada}
                    buscarEmpresas={this.buscarEmpresasGestao.bind(this)} />
                <ModalConfirmacaoBloqueioEmpresa
                    bloquearDesbloquear={this.bloquearDesbloquear.bind(this)}
                    empresa={this.state.empresaSelecionada} />

                <div className='modal fade' id='modalCieloLinkEmpresa' tabIndex='-1' role='dialog' aria-hidden='true'>
                    <div className='modal-dialog modal-dialog-centered' role='document'>
                        <div className='modal-content' style={{borderTop:'4px solid #FF6A00', borderRadius:12}}>
                            <div className='modal-header' style={{borderBottom:'1px solid #f0f0f0'}}>
                                <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                                    <i className='material-icons' style={{color:'#FF6A00', fontSize:20}}>credit_card</i>
                                    Cielo Link — {this.state.empresaSelecionada && this.state.empresaSelecionada.nomeFantasia}
                                </h5>
                                <button type='button' className='close' data-dismiss='modal'><i className='material-icons'>close</i></button>
                            </div>
                            <div className='modal-body'>
                                <div className='form-group'>
                                    <div className='form-check mb-3'>
                                        <input className='form-check-input' type='checkbox' id='habilitadoLinkPagamento'
                                            checked={this.state.cieloLink.habilitadoLinkPagamento}
                                            onChange={e => this.setState({ cieloLink: { ...this.state.cieloLink, habilitadoLinkPagamento: e.target.checked } })} />
                                        <label className='form-check-label' htmlFor='habilitadoLinkPagamento'>
                                            Habilitar Venda Link Pagamento (Cielo)
                                        </label>
                                    </div>
                                    <label>Client ID</label>
                                    <input className='form-control mb-2' type='text' placeholder='Client ID Cielo Link'
                                        value={this.state.cieloLink.clientIdCieloLink}
                                        onChange={e => this.setState({ cieloLink: { ...this.state.cieloLink, clientIdCieloLink: e.target.value } })} />
                                    <label>Client Secret</label>
                                    <input className='form-control' type='password' placeholder='Client Secret Cielo Link'
                                        value={this.state.cieloLink.clientSecretCieloLink}
                                        onChange={e => this.setState({ cieloLink: { ...this.state.cieloLink, clientSecretCieloLink: e.target.value } })} />
                                </div>
                            </div>
                            <div className='modal-footer'>
                                <button type='button' className='btn btn-secondary' data-dismiss='modal'>Cancelar</button>
                                <button type='button' className='btn btn-laranja' onClick={() => this.salvarCieloLink()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='modal fade' id='modalCieloEcommerceEmpresa' tabIndex='-1' role='dialog' aria-hidden='true'>
                    <div className='modal-dialog modal-dialog-centered' role='document'>
                        <div className='modal-content' style={{borderTop:'4px solid #003087', borderRadius:12}}>
                            <div className='modal-header' style={{borderBottom:'1px solid #f0f0f0'}}>
                                <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                                    <i className='material-icons' style={{color:'#003087', fontSize:20}}>crop_free</i>
                                    Cielo E-commerce — {this.state.empresaSelecionada && this.state.empresaSelecionada.nomeFantasia}
                                </h5>
                                <button type='button' className='close' data-dismiss='modal'><i className='material-icons'>close</i></button>
                            </div>
                            <div className='modal-body'>
                                <div className='form-group'>
                                    <div className='form-check mb-3'>
                                        <input className='form-check-input' type='checkbox' id='habilitadoCieloEcommerce'
                                            checked={this.state.cieloEcommerce.habilitadoCieloEcommerce}
                                            onChange={e => this.setState({ cieloEcommerce: { ...this.state.cieloEcommerce, habilitadoCieloEcommerce: e.target.checked } })} />
                                        <label className='form-check-label' htmlFor='habilitadoCieloEcommerce'>
                                            Habilitar Venda via PIX (Cielo E-commerce)
                                        </label>
                                    </div>
                                    <label>Merchant ID</label>
                                    <input className='form-control mb-2' type='text' placeholder='Merchant ID'
                                        value={this.state.cieloEcommerce.merchantIdCieloEcommerce}
                                        onChange={e => this.setState({ cieloEcommerce: { ...this.state.cieloEcommerce, merchantIdCieloEcommerce: e.target.value } })} />
                                    <label>Merchant Key</label>
                                    <input className='form-control' type='password' placeholder='Merchant Key'
                                        value={this.state.cieloEcommerce.merchantKeyCieloEcommerce}
                                        onChange={e => this.setState({ cieloEcommerce: { ...this.state.cieloEcommerce, merchantKeyCieloEcommerce: e.target.value } })} />
                                </div>
                            </div>
                            <div className='modal-footer'>
                                <button type='button' className='btn btn-secondary' data-dismiss='modal'>Cancelar</button>
                                <button type='button' className='btn btn-laranja' onClick={() => this.salvarCieloEcommerce()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='modal fade' id='modalSicoobEmpresa' tabIndex='-1' role='dialog' aria-hidden='true'>
                    <div className='modal-dialog modal-dialog-centered modal-lg' role='document'>
                        <div className='modal-content' style={{borderTop:'4px solid #003087', borderRadius:12}}>
                            <div className='modal-header' style={{borderBottom:'1px solid #f0f0f0'}}>
                                <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                                    <i className='material-icons' style={{color:'#003087', fontSize:20}}>account_balance</i>
                                    Sicoob PIX — {this.state.empresaSelecionada && this.state.empresaSelecionada.nomeFantasia}
                                </h5>
                                <button type='button' className='close' data-dismiss='modal'><i className='material-icons'>close</i></button>
                            </div>
                            <div className='modal-body'>
                                <div className='form-group'>
                                    <div className='form-check mb-3'>
                                        <input className='form-check-input' type='checkbox' id='habilitadoSicoob'
                                            checked={this.state.sicoob.habilitadoSicoob}
                                            onChange={e => this.setState({ sicoob: { habilitadoSicoob: e.target.checked } }, () => this.salvarSicoob())} />
                                        <label className='form-check-label' htmlFor='habilitadoSicoob'>
                                            Habilitar Venda via PIX (Sicoob)
                                        </label>
                                    </div>

                                    <small className='form-text text-muted mb-2'>
                                        O certificado digital não é único da empresa — cada configuração abaixo (geral ou
                                        por estado) tem seu próprio certificado, client ID e chave PIX, já que o
                                        certificado pode variar por CNPJ/filial (igual à configuração de BPe). Cadastre uma
                                        configuração &quot;Geral&quot; para cobrir todos os estados sem configuração própria,
                                        e (opcionalmente) configurações específicas por estado.
                                    </small>

                                    {this.state.chavesPixSicoob.length > 0 && (
                                        <div className='table-responsive'>
                                        <table className='table table-sm mb-3'>
                                            <thead>
                                                <tr>
                                                    <th style={thStyle}>UF</th>
                                                    <th style={thStyle}>Chave PIX</th>
                                                    <th style={thStyle}>Apelido</th>
                                                    <th style={thStyle}>Client ID</th>
                                                    <th style={thStyle}>Ambiente</th>
                                                    <th style={thStyle}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.chavesPixSicoob.map(chave => (
                                                    <React.Fragment key={chave.id}>
                                                        <tr>
                                                            <td>{chave.uf || 'Geral'}</td>
                                                            <td>{chave.chavePix}</td>
                                                            <td>{chave.apelido}</td>
                                                            <td style={{maxWidth:120, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}} title={chave.clientId}>{chave.clientId}</td>
                                                            <td>{chave.ambiente}</td>
                                                            <td style={{whiteSpace:'nowrap'}}>
                                                                {chave.uf && (
                                                                    <button type='button' className='btn btn-link p-0 mr-2' title='Replicar para outros estados'
                                                                        onClick={() => this.abrirReplicar(chave.id)}>
                                                                        <i className='material-icons' style={{fontSize:18}}>content_copy</i>
                                                                    </button>
                                                                )}
                                                                <button type='button' className='btn btn-link text-danger p-0'
                                                                    onClick={() => this.removerChavePixSicoob(chave.id)}>
                                                                    <i className='material-icons' style={{fontSize:18}}>delete</i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        {this.state.configuracaoReplicandoId === chave.id && (
                                                            <tr>
                                                                <td colSpan='6' style={{background:'#f8f8f8'}}>
                                                                    <div style={{fontSize:12, fontWeight:700, marginBottom:6}}>
                                                                        Replicar certificado/client ID/chave desta configuração para:
                                                                    </div>
                                                                    <div style={{display:'flex', flexWrap:'wrap', gap:8, marginBottom:8}}>
                                                                        {UF_SICOOB.filter(uf => uf !== chave.uf).map(uf => (
                                                                            <label key={uf} style={{fontWeight:400, marginBottom:0}}>
                                                                                <input type='checkbox'
                                                                                    checked={this.state.ufsReplicar.includes(uf)}
                                                                                    onChange={() => this.toggleUfReplicar(uf)} /> {uf}
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                                    <button type='button' className='btn btn-laranja btn-sm' onClick={() => this.confirmarReplicar()}>
                                                                        Replicar
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    )}

                                    <hr />
                                    <h6 style={{fontWeight:700, marginBottom:10}}>Nova configuração</h6>

                                    <div className='form-row'>
                                        <div className='form-group col-3'>
                                            <label>UF</label>
                                            <select className='form-control'
                                                value={this.state.novaConfiguracaoSicoob.uf}
                                                onChange={e => this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, uf: e.target.value } })}>
                                                <option value=''>Geral (todos os estados)</option>
                                                {UF_SICOOB.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                                            </select>
                                        </div>
                                        <div className='form-group col-5'>
                                            <label>Chave PIX</label>
                                            <input className='form-control' type='text' placeholder='Chave PIX'
                                                value={this.state.novaConfiguracaoSicoob.chavePix}
                                                onChange={e => this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, chavePix: e.target.value } })} />
                                        </div>
                                        <div className='form-group col-4'>
                                            <label>Apelido (opcional)</label>
                                            <input className='form-control' type='text' placeholder='Ex.: Matriz SP'
                                                value={this.state.novaConfiguracaoSicoob.apelido}
                                                onChange={e => this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, apelido: e.target.value } })} />
                                        </div>
                                    </div>
                                    <div className='form-row'>
                                        <div className='form-group col-4'>
                                            <label>Client ID</label>
                                            <input className='form-control' type='text' placeholder='Client ID'
                                                value={this.state.novaConfiguracaoSicoob.clientId}
                                                onChange={e => this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, clientId: e.target.value } })} />
                                        </div>
                                        {isAmbienteDev() ? (
                                            <div className='form-group col-8'>
                                                <label>Access Token (sandbox)</label>
                                                <input className='form-control' type='text' placeholder='Access Token obtido no ambiente sandbox da Sicoob'
                                                    value={this.state.novaConfiguracaoSicoob.accessTokenSandbox}
                                                    onChange={e => this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, accessTokenSandbox: e.target.value } })} />
                                            </div>
                                        ) : (
                                            <React.Fragment>
                                                <div className='form-group col-4'>
                                                    <label>Certificado digital (.pfx)</label>
                                                    <div className='input-wrapper'>
                                                        <label htmlFor='input-file-certificado-sicoob'>
                                                            {this.state.novaConfiguracaoSicoob.nomeCertificado ? 'Alterar certificado' : 'Selecionar certificado'}
                                                        </label>
                                                        <input id='input-file-certificado-sicoob' type='file' value='' accept='.pfx,.p12'
                                                            onChange={e => this.handleCertificadoSicoob(e.target.files[0])} />
                                                        <span>{this.state.novaConfiguracaoSicoob.nomeCertificado}</span>
                                                    </div>
                                                </div>
                                                <div className='form-group col-4'>
                                                    <label>Senha do certificado</label>
                                                    <input className='form-control' type='password' placeholder='Senha'
                                                        value={this.state.novaConfiguracaoSicoob.senhaCertificado}
                                                        onChange={e => this.setState({ novaConfiguracaoSicoob: { ...this.state.novaConfiguracaoSicoob, senhaCertificado: e.target.value } })} />
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <button type='button' className='btn btn-laranja btn-sm' onClick={() => this.salvarNovaConfiguracaoSicoob()}>
                                        + Adicionar configuração
                                    </button>
                                </div>
                            </div>
                            <div className='modal-footer'>
                                <button type='button' className='btn btn-secondary' data-dismiss='modal'>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='modal fade' id='modalStoneConnectEmpresa' tabIndex='-1' role='dialog' aria-hidden='true'>
                    <div className='modal-dialog modal-dialog-centered modal-lg' role='document'>
                        <div className='modal-content' style={{borderTop:'4px solid #00b140', borderRadius:12}}>
                            <div className='modal-header' style={{borderBottom:'1px solid #f0f0f0'}}>
                                <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                                    <i className='material-icons' style={{color:'#00b140', fontSize:20}}>tap_and_play</i>
                                    Stone Connect — {this.state.empresaSelecionada && this.state.empresaSelecionada.nomeFantasia}
                                </h5>
                                <button type='button' className='close' data-dismiss='modal'><i className='material-icons'>close</i></button>
                            </div>
                            <div className='modal-body'>
                                <div className='form-group'>
                                    <div className='form-check mb-3'>
                                        <input className='form-check-input' type='checkbox' id='habilitadoStoneConnect'
                                            checked={this.state.stoneConnect.habilitadoStoneConnect}
                                            onChange={e => this.setState({ stoneConnect: { ...this.state.stoneConnect, habilitadoStoneConnect: e.target.checked } })} />
                                        <label className='form-check-label' htmlFor='habilitadoStoneConnect'>
                                            Habilitar Connect Stone
                                        </label>
                                        {this.exibirIconeAjudaCampo('tt-stone-habilitado',
                                            'Ativa a modalidade de pagamento por maquininha Stone para esta empresa. Só fica disponível para o operador na venda se também estiver habilitado para o usuário (tela de usuários).')}
                                    </div>

                                    {this.state.stoneConnect.habilitadoStoneConnect && (
                                        <div className='form-group mb-3'>
                                            <label>Meios de pagamento habilitados
                                                {this.exibirIconeAjudaCampo('tt-stone-meios-pagamento',
                                                    'Meios de pagamento que ficam disponíveis no combo "Forma de pagamento na maquininha" na hora da venda. Selecione ao menos um.')}
                                            </label>
                                            {[['credit', 'Crédito'], ['debit', 'Débito'], ['pix', 'PIX']].map(([valor, texto]) => (
                                                <div className='form-check' key={valor}>
                                                    <input className='form-check-input' type='checkbox' id={`meioPagamentoStone-${valor}`}
                                                        checked={this.state.stoneConnect.meiosPagamentoHabilitados.includes(valor)}
                                                        onChange={e => this.toggleMeioPagamentoStone(valor, e.target.checked)} />
                                                    <label className='form-check-label' htmlFor={`meioPagamentoStone-${valor}`}>{texto}</label>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {this.state.stoneConnect.habilitadoStoneConnect && (
                                        <div className='form-group mb-3'>
                                            <label>Modo de criação do pedido
                                                {this.exibirIconeAjudaCampo('tt-stone-modo-criacao',
                                                    'Modos de criação do pedido disponíveis na hora da venda: Pagamento Direto (forma de pagamento definida de antemão) e/ou Listar Pedido (forma escolhida pelo comprador/operador na própria maquininha). Selecione ao menos um.')}
                                            </label>
                                            {[['PAGAMENTO_DIRETO', 'Pagamento Direto'], ['LISTADO', 'Listar Pedido']].map(([valor, texto]) => (
                                                <div className='form-check' key={valor}>
                                                    <input className='form-check-input' type='checkbox' id={`modoCriacaoPedidoStone-${valor}`}
                                                        checked={this.state.stoneConnect.modosCriacaoPedidoHabilitados.includes(valor)}
                                                        onChange={e => this.toggleModoCriacaoPedidoStone(valor, e.target.checked)} />
                                                    <label className='form-check-label' htmlFor={`modoCriacaoPedidoStone-${valor}`}>{texto}</label>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <label>ServiceRefererName
                                        {this.exibirIconeAjudaCampo('tt-stone-referer',
                                            'ID único de referência da empresa parceira com o Stone Partner Program. Consulte com o time de Integrações ou seu Bizdev.')}
                                    </label>
                                    <input className='form-control mb-2' type='text' placeholder='ServiceRefererName'
                                        value={this.state.stoneConnect.serviceRefererName}
                                        onChange={e => this.setState({ stoneConnect: { ...this.state.stoneConnect, serviceRefererName: e.target.value } })} />

                                    <label>Chave Secreta
                                        {this.exibirIconeAjudaCampo('tt-stone-chave',
                                            'Sua chave secreta (SK), usada para autenticar todas as chamadas à API da Stone via Basic Auth. Enviada junto com o ServiceRefererName, que vai num header HTTP à parte. Por segurança, este campo nunca mostra o valor já cadastrado — para trocar a chave, digite a nova; para manter a atual, deixe em branco.')}
                                    </label>
                                    <input className='form-control' type='password'
                                        placeholder={this.state.stoneConnect.chaveSecretaConfigurada ? 'Chave secreta já cadastrada — deixe em branco para manter' : 'Chave Secreta'}
                                        value={this.state.stoneConnect.chaveSecreta}
                                        onChange={e => this.setState({ stoneConnect: { ...this.state.stoneConnect, chaveSecreta: e.target.value } })} />
                                    {this.state.stoneConnect.chaveSecretaConfigurada && (
                                        <small className='form-text text-muted mb-2'>Chave secreta já cadastrada — deixe em branco para manter a atual.</small>
                                    )}

                                    <label className='mt-2'>Quem paga os juros do parcelamento
                                        {this.exibirIconeAjudaCampo('tt-stone-installment',
                                            'Define quem absorve os juros das vendas parceladas no crédito: Lojista (a empresa) ou Portador do cartão (o cliente). Vale para todas as vendas Connect Stone da empresa — não é escolhido na hora da venda.')}
                                    </label>
                                    <select className='form-control mb-3'
                                        value={this.state.stoneConnect.installmentType}
                                        onChange={e => this.setState({ stoneConnect: { ...this.state.stoneConnect, installmentType: e.target.value } })}>
                                        <option value='merchant'>Lojista (merchant)</option>
                                        <option value='issuer'>Portador do cartão (issuer)</option>
                                    </select>

                                    {this.state.stoneConnect.meiosPagamentoHabilitados.includes('credit') && (
                                        <>
                                            <label className='mt-2'>Limite de parcelamento
                                                {this.exibirIconeAjudaCampo('tt-stone-limite-parcelamento',
                                                    'Quantidade máxima de parcelas permitida nas vendas via crédito por Connect Stone desta empresa. Se não configurado, o combo de parcelas na venda mostra até 12x.')}
                                            </label>
                                            <select className='form-control mb-3'
                                                value={this.state.stoneConnect.limiteParcelamento || 12}
                                                onChange={e => this.setState({ stoneConnect: { ...this.state.stoneConnect, limiteParcelamento: Number(e.target.value) } })}>
                                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(n => (
                                                    <option key={n} value={n}>{n}x</option>
                                                ))}
                                            </select>
                                        </>
                                    )}

                                    <button type='button' className='btn btn-laranja btn-sm mb-3' onClick={() => this.salvarStoneConnect()}>
                                        Salvar credencial
                                    </button>
                                    <small className='form-text text-muted'>
                                        As maquininhas de cada usuário são cadastradas na tela de Editar/Cadastrar Usuário.
                                    </small>
                                </div>
                            </div>
                            <div className='modal-footer'>
                                <button type='button' className='btn btn-secondary' data-dismiss='modal'>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    return {
        empresas: state.empresasGestao.empresas,
        total: state.empresasGestao.total,
        impostosEmpresa: state.impostoEmpresa.impostosEmpresa,
        paginaAtual: state.paginaAtualEmpresa,
        registrosPorPagina: state.registrosPorPaginaEmpresa,
        filtrosAdicionados: state.filtrosAdicionadosEmpresas,
    }
};


export default connect(mapStateToProps,
    {
        buscarEmpresasGestao,
        excluirEmpresa,
        buscarImpostosEmpresa,
        buscarImpostos,
        determinarPaginaAtual,
        alterarRegistrosPorPagina,
        desbloquearEmpresa,
        bloquearEmpresa,
        configurarCieloLinkEmpresa,        
        configurarCieloEcommerceEmpresa,
        configurarSicoobEmpresa,
        listarChavesPixSicoob,
        cadastrarChavePixSicoob,
        removerChavePixSicoob,
        replicarConfiguracaoSicoob,
        recuperarConfiguracaoStoneConnect,
        configurarStoneConnect,
        buscarEmpresaPorId
    })(PainelGerenciarEmpresas)
